import { IGetInsurerInformationTabsAlertsParams } from '@/modules/adjusterReportModules/Insurer-information/queries/getInsurerInformationTabsAlerts/getInsurerInformationTabsAlertsQuery.type';
import { getInsurerInformationTabsAlertsQueryFunctions } from '@/modules/adjusterReportModules/Insurer-information/queries/getInsurerInformationTabsAlerts/getInsurerInformationTabsAlertsQueryFunctions';
import { queryOptions } from '@tanstack/react-query';

const getInsurerInformationTabsAlertsQueryOptions = (
  params: IGetInsurerInformationTabsAlertsParams,
) =>
  queryOptions({
    queryKey: ['getInsurerInformationTabsAlert', params],
    queryFn: () => getInsurerInformationTabsAlertsQueryFunctions(params),
  });
export default getInsurerInformationTabsAlertsQueryOptions;
